import React from 'react';
import './FloatingElements.css';

/**
 * FloatingElements Component
 * Floating background animation with configurable element count
 * 
 * @param {string} className - Additional CSS classes
 * @param {number} elementCount - Number of floating elements (default: 3)
 * @param {boolean} monochrome - Use monochrome/greyscale animation instead of colorful (default: false)
 */
const FloatingElements = ({ className = '', elementCount = 3, monochrome = false }) => {
  const elements = Array.from({ length: elementCount }, (_, i) => i + 1);
  const monochromeClass = monochrome ? 'floating-elements-monochrome' : '';

  return (
    <div className={`floating-elements ${monochromeClass} ${className}`.trim()}>
      {elements.map((index) => (
        <div 
          key={index} 
          className={`floating-element element-${index}`}
          style={{
            animationDelay: `${index * 0.5}s`,
            animationDuration: `${3 + index * 0.5}s`
          }}
        />
      ))}
    </div>
  );
};

export default FloatingElements;














